import React, { useContext, useEffect } from 'react';
import { useAjax } from './use-ajax';
import { useAuth } from './use-auth';

export type ApisType = {
	apiColumns: {
		code: string;
		name: string;
	}[];
	apiDesc: string;
	apiName: string;
}[];

type CompaniesType = {
	code: string;
	id: number;
	name: string;
}[];

export interface IOptions {
	apis?: ApisType;

	companies?: CompaniesType;
}

interface IOptionsContext extends IOptions {
	loading: boolean;
}

const OptionsContext = React.createContext<IOptionsContext>({ loading: true });

const OptionsProvider = ({ children }: { children: React.ReactNode }) => {
	const { isLogin } = useAuth();
	const [run, loading, data] = useAjax<IOptionsContext>({
		url: '/api/manage/privilege/options',
		method: 'get',
	});

	useEffect(() => {
		isLogin && run();
	}, [run, isLogin]);

	return <OptionsContext.Provider value={{ ...data, loading }}>{children}</OptionsContext.Provider>;
};

const useOptions = () => {
	return useContext(OptionsContext);
};

export { OptionsProvider, useOptions };
